const pako = require('pako');

import { LoadPlugin } from '@goodboydigital/astro';
import { extname } from 'path';

/**
 * simple loader plugin for loading json data
 */
const loadJsonZip = {
    test(url: string): boolean
    {
        return (extname(url).includes('.jsz'));
    },

    async load<T>(url: string): Promise<T>
    {
        const response = await fetch(url);
        const buffer = await response.arrayBuffer();
        const json = JSON.parse(pako.inflate(buffer, { to: 'string' }));

        return json;
    },
} as LoadPlugin;

export { loadJsonZip };

